import { useQuery } from "react-query";
import { itemTypesApi, type ItemType } from "@/lib/api/item-types";

export const ITEM_TYPES_QUERY_KEY = ["item-types"] as const;

export function useItemTypes(includeInactive = true, options?: { enabled?: boolean }) {
  return useQuery<ItemType[]>(
    [...ITEM_TYPES_QUERY_KEY, includeInactive],
    () => itemTypesApi.getAll(includeInactive),
    { staleTime: 60 * 60 * 1000, enabled: options?.enabled ?? true }
  );
}
